module.exports = __webpack_public_path__ + "img/lvting.3eec070b.jpg";